import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    slopeId: 2,
    user: null,
    resources: null,
    date: null,
    token: localStorage.getItem('token'),
    flightLog: null
  },
  mutations: {
    setSlopeId(state,slopeId) {
      state.slopeId=slopeId
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token',token)
    },
    setFlightLog(state, flightLog) {
      console.log(flightLog)
      state.flightLog = flightLog
    },
    setActiveSupervisor(state,activeSupervisor) {
      state.flightLog.activeSupervisor = activeSupervisor
    },
    setActivePilot(state,activePilot) {
      state.flightLog.activePilot = activePilot
    },
    setUser(state,user) {
      state.user = user
    },
    setResources(state,resources){
      state.resources = resources
      console.log(state.resources)
    },
    setSupervisorLogEndTime(state,upd){
      let {id,endTime} = upd
      let index = state.flightLog.supervisorLogs.findIndex(s=>s.id===id)
      state.flightLog.supervisorLogs[index].endTime = endTime
    },
    addSupervisorLog(state, supervisorLog){
      state.flightLog.supervisorLogs.push(supervisorLog)
    },
    setPilotLogEndTime(state,upd){
      let {id,endTime} = upd
      let index = state.flightLog.pilotLogs.findIndex(p=>p.id===id)
      state.flightLog.pilotLogs[index].endTime = endTime
    },
    addPilotLog(state, pilotLog){
      state.flightLog.pilotLogs.push(pilotLog)
    },
    addIncidentLog(state, incidentLog){
      state.flightLog.incidentLogs.push(incidentLog)
    },
    setDate(state,date) {
      state.date=date
    }
    
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post('./api/auth/login', credentials)
        commit ('setToken', response.data)
      } catch (error) {
        throw error
      }
    },

    async changePassword ({ commit }, changeCredentials) {
      try {
        console.log(changeCredentials)
        const response = await axios.post('./api/users/changePassword', changeCredentials,{
          headers: {
            Authorization: 'Bearer ' + this.state.token
          }
        })
        commit ('setToken', response.data)
      } catch (error) {
        throw error
      }
    },

    logout ({commit}) {
      commit ('setToken', null)

    },

    async refresh({ commit }, slopeId) {
      console.log ('Refresh')
      const response = await axios.get('./api/flightLog?slopeId=' + slopeId, {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      console.log('Response Data')
      console.log(response.data)
      commit('setFlightLog', response.data)
      commit('setSlopeId', slopeId)
    },

    async init({ commit }) {
      const responseResources = await axios.get('./api/flightLog/resources' , {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      const responseUser = await axios.get('./api/flightLog/users/currentUser' , {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      const responseDate = await axios.get('./api/flightLog/date' , {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      commit('setResources', responseResources.data)
      commit('setUser', responseUser.data)
      commit('setDate', responseDate.data)
    },
    async signOutSupervisor({ commit }, supervisorLogId) {
      const response = await axios.patch('./api/flightLog/supervisorLogs/' + supervisorLogId ,{endTime:null} ,{
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      commit('setSupervisorLogEndTime',{id:supervisorLogId, endTime: response.data.endTime})
      commit('setActiveSupervisor', false)
    },
    async signInSupervisor({ commit }, supervisor) {
      const response = await axios.post('./api/flightLog/supervisorLogs' , supervisor, {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      commit('addSupervisorLog',response.data)
      commit('setActiveSupervisor', true)
    },

    async signOutPilot({ commit }, pilotLogId) {
      const response = await axios.patch('./api/flightLog/pilotLogs/' + pilotLogId ,{endTime:null} ,{
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      },)
      commit('setPilotLogEndTime',{id:pilotLogId, endTime: response.data.endTime})
      commit('setActivePilot', false)
    },
    async signInPilot({ commit }, pilotLog) {
      console.log('dispatch signInPilot')
      const response = await axios.post('./api/flightLog/pilotLogs' , pilotLog, {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      commit('addPilotLog',response.data)
      commit('setActivePilot', true)
    },
    async addIncident({ commit }, incidentLog) {
      console.log('Store-Index.js addIncident')
      
      console.log(incidentLog)
      
      console.log('Bearer ' + this.state.token)

      const response = await axios.post('./api/flightLog/incidentLogs' , incidentLog, {
        headers: {
          Authorization: 'Bearer ' + this.state.token
        }
      })
      commit('addIncidentLog',response.data)

    }


  },
  modules: {
  }
})
